'use client';

import { Loader2 } from 'lucide-react';
import { useAuthGuard } from '@/hooks/useAuthGuard';

export default function EaiRoboticsOrgChartPage() {
  const { isReady } = useAuthGuard();

  if (!isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0e1014]">
        <Loader2 className="w-8 h-8 animate-spin text-white" />
      </div>
    );
  }

  return (
    <iframe
      src="/showcase-pages/eai-robotics-org-chart.html"
      title="EAI Robotics Organization Chart"
      className="fixed inset-0 w-screen h-screen border-0"
    />
  );
}
